const translations = {
    en: {
        welcome: {
            cards: {
                // bwr: {
                //     header: "BW Rewards®",
                //     title: "Be Special.",
                //     text: "Special prices, prizes and many advantages for you, our Member.",
                //     button_text: "CHECK YOUR POINTS BALANCE"
                // },
                // no_bwr: {
                //     header: "BW Rewards®",
                //     title: "Go. Get. Rewarded.®",
                //     text: "Discover all the advantages of our loyalty program.",
                //     button_text: "SIGN ME UP!"
                // },
                reach: {
                    header: "HOW TO ARRIVE",
                    title: "Reach the Hotel.",
                    text: "Find the best way to reach us.",
                    button_text: "DISCOVER"
                },
                events: {
                    header: "EVENTS AND ATTRACTIONS",
                    title: "Find out what's happening around.",
                    text: "Enjoy the attractions and experience of all events near you.",
                    button_text: "DISCOVER"
                },
                restaurants: {
                    header: "BREAKFAST & RESTAURANTS",
                    title: "Hungry? No problem.",
                    text: "Discover the best surrounding restaurants and the delicacies that await you at the ${hotel}. Your taste buds will thank you!",
                    button_text: "DISCOVER"
                },
                additional: {
                    header: "BEST WESTERN WORLD",
                    button_text: "DISCOVER"
                }
            }
        }
    },
    de: {
        welcome: {
            cards: {
                // bwr: {
                //     header: "BW Rewards®",
                //     title: "Du bist etwas Besonderes für uns.",
                //     text: "Tarife, Preise und viele Vorteile für unsere Mitglieder.",
                //     button_text: "PUNKTENGUTHABEN "
                // },
                // no_bwr: {
                //     header: "BW Rewards®",
                //     title: "Go. Get. Rewarded.®",
                //     text: "Entdecken Sie alle Vorteile unseres Treueprogramms.",
                //     button_text: "JETZT ANMELDUNGEN!"
                // },
                reach: {
                    header: "DAS WEG ZU UNS",
                    title: "Wir warten auf Sie.",
                    text: "Suchen Sie den schnellsten Weg zu uns.",
                    button_text: "ENTDECKEN"
                },
                events: {
                    header: "EREIGNISSE UND ATTRAKTIONEN",
                    title: "Finde heraus, was um dich herum passiert.",
                    text: "Genießen Sie die Attraktionen und Erfahrungen aller Veranstaltungen in Ihrer Nähe.",
                    button_text: "ENTDECKEN"
                },
                restaurants: {
                    header: "Frühstück und Restaurants",
                    title: "Hunger? Kein Problem.",
                    text: "Entdecken Sie die besten umliegenden Restaurants und die Köstlichkeiten, die Sie im ${hotel} erwarten. Ihre Geschmacksnerven werden es Ihnen danken!",
                    button_text: "ENTDECKEN"
                },
                additional: {
                    header: "BEST WESTERN WORLD",
                    button_text: "ENTDECKEN"
                }
            }
        }
    },
    es: {
        welcome: {
            cards: {
                // bwr: {
                //     header: "BW Rewards®",
                //     title: "Sientete Especial.",
                //     text: "Precios Especiales, premios y muchas ventajas para nuestros miembros.",
                //     button_text: "Consultar el saldo de sus puntos Best Western Rewards"
                // },
                // no_bwr: {
                //     header: "BW Rewards®",
                //     title: "Subscribanse y empiece a obtener puntos, desde ahora.®",
                //     text: "Descubra todos los beneficios de nuestro programa Best Western Rewards.",
                //     button_text: "Unanse a nuestro programa de lealtad!"
                // },
                reach: {
                    header: "COMO LLEGAR",
                    title: "Como llegar al hotel.",
                    text: "Encuentra la manera mas rapida para llegar.",
                    button_text: "Descubra"
                },
                events: {
                    header: "EVENTOS Y ATRACCIONES",
                    title: "Chequea lo que pasa a tu alrededor.",
                    text: "Aprovecha de las atracciones y no pierda los eventos cerca de usted .",
                    button_text: "Descubra"
                },
                restaurants: {
                    header: "DESAYUNO Y RESTAURANTES",
                    title: "Tiene hambre? Ningun problema.",
                    text: "Descubra los mejores restaurantes cerca y las delicias culinarias que la esperan en el ${hotel}. Sus papilas gustativas se los van a agradecer",
					button_text: "Descubra"
                },
                additional: {
                    header: "EL MUNDO BEST WESTERN",
                    button_text: "Descubra"
                }
            }
        }
    },
    fr: {
        welcome: {
            cards: {
                // bwr: {
                //     header: "BW Rewards®",
                //     title: "Tu es spécial.",
                //     text: "Des prix spéciaux, des prix et de nombreux avantages pour vous en tant que notre membre.",
                //     button_text: "VERIFIEZ VOTRE SOLDE DE POINTS"
                // },
                // no_bwr: {
                //     header: "BW Rewards®",
                //     title: "Go. Get. Rewarded.®",
                //     text: "Découvrez tous les avantages de notre programme de fidélité.",
                //     button_text: "ENREGISTRE-MOI!"
                // },
                reach: {
                    header: "COMMENT ARRIVER",
                    title: "ATTEINDRE L'HÔTEL",
                    text: "Trouvez le meilleur moyen de nous joindre.",
                    button_text: "DÉCOUVREZ"
                },
                events: {
                    header: "Événements & Attractions",
                    title: "Découvrez ce qui se passe dans la ville",
                    text: "Profitez des attractions et découvrez les événements.",
                    button_text: "DÉCOUVREZ"
                },
                restaurants: {
                    header: "PETIT-DEJEUNER & RESTAURANTS",
                    title: "Avez vous faim? Pas de problème.",
                    text: "Découvrez les meilleurs restaurants dans les environs et les délices qui vous attendent au ${hotel}. Vos papilles vous remercieront!",
                    button_text: "DÉCOUVREZ"
                },
                additional: {
                    header: "BEST WESTERN WORLD",
                    button_text: "DÉCOUVREZ"
                }
            }
        }
    },
    it: {
        welcome: {
            cards: {
                // bwr: {
                //     header: "BW Rewards®",
                //     title: "Per noi sei speciale.",
                //     text: "Tariffe, premi e tanti vantaggi per te che sei nostro Socio.",
                //     button_text: "VERIFICA IL TUO SALDO PUNTI"
                // },
                // no_bwr: {
                //     header: "BW Rewards®",
                //     title: "Go. Get. Rewarded.®",
                //     text: "Scopri tutti i vantaggi del nostro programma fedeltà.",
                //     button_text: "ISCRIVITI GRATUITAMENTE"
                // },
                reach: {
                    header: "COME RAGGIUNGERCI",
                    title: "Ti aspettiamo in Hotel.",
                    text: "Scopri il percorso più comodo per raggiungerci.",
                    button_text: "PARTI ORA"
                },
                events: {
                    header: "EVENTI ED ATTRAZIONI",
                    title: "Scopri cosa succede in città.",
                    text: "Goditi le attrazioni e vivi gli eventi.",
                    button_text: "SCOPRI DI PIU'"
                },
                restaurants: {
                    header: "COLAZIONE & RISTORANTI",
                    title: "Cosa vuoi mangiare? Ci pensiamo noi.",
                    // text: "Fai felice il tuo palato: scopri i migliori locali in zona e le bontà che ti aspettano al ${hotel}",
                    text: "Prenota la tua cena in sicurezza, ecco tutte le soluzioni.",
                    button_text: "SCOPRI DI PIU'"
                },
                additional: {
                    header: "BEST WESTERN WORLD",
                    button_text: "SCOPRI DI PIU'"
                }
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/welcome/Cards.js